var _ellipse, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyStateOrders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 120,
    viewBox: "0 0 112 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.9998,
    cy: 64.5865,
    rx: 55.4136,
    ry: 55.4136,
    fill: "#EDEEF0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2121_4689",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -14,
    y: -38,
    width: 168,
    height: 158
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16687 44.9491L-13.4998 21.001L-3.99976 -26.999L44.5002 -37.499L144.5 -12.499L153.5 94.501L109.5 117.501L86.4621 110.884C77.7216 116.646 67.2526 120 56.0003 120C25.3962 120 0.58667 95.1906 0.58667 64.5865C0.58667 57.6717 1.85318 51.0528 4.16687 44.9491Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2121_4689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.0515 0.915039L89.5646 9.40357L82.0777 0.915039H26.9227L17.9739 105H106L97.0515 0.915039Z",
    fill: "#F4F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5128 95.8027L106 105.002H91.0259L98.5128 95.8027Z",
    fill: "#DEDFE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0774 0.915039H11.9486L2.99976 105H91.0263L82.0774 0.915039Z",
    fill: "#CACBCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4083 55.1789C36.1812 55.1789 26.2134 45.1794 26.2134 32.9132V12.8696C26.2134 11.6252 27.188 10.6475 28.4284 10.6475C29.6689 10.6475 30.6435 11.6252 30.6435 12.8696V32.9132C30.6435 42.735 38.6177 50.7347 48.4083 50.7347C58.1989 50.7347 66.1731 42.735 66.1731 32.9132V12.8696C66.1731 11.6252 67.1477 10.6475 68.3881 10.6475C69.6286 10.6475 70.6032 11.6252 70.6032 12.8696V32.9132C70.6032 45.1794 60.6797 55.1789 48.4083 55.1789Z",
    fill: "#F4F6F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5002 10.001L97.0002 1.00098H82.0002L89.5002 10.001Z",
    fill: "#EDEEF0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateOrders);
export default __webpack_public_path__ + "static/media/empty-state-orders.16b839b2.svg";
export { ForwardRef as ReactComponent };